import React from 'react';
import { Star } from 'lucide-react';
import { useGoogleReviews } from '../../hooks/useGoogleReviews';

/** Pastille de note Google, renvoie vers la section #avis. Rien tant que les données manquent. */
const ReviewsBadge: React.FC = () => {
  const { data } = useGoogleReviews();

  if (!data || data.rating === null || data.userRatingCount === null) return null;

  const rating = data.rating.toFixed(1).replace('.', ',');
  const count = data.userRatingCount;

  return (
    <a
      href="#avis"
      data-reviews-badge
      aria-label={`Note Google ${rating} sur 5, ${count} avis — voir les avis`}
      className="badge-mono inline-flex min-h-11 items-center gap-2 transition-colors hover:text-accent-soft"
    >
      <Star size={14} fill="currentColor" className="shrink-0 text-accent-soft" aria-hidden />
      <span>
        {rating} · {count} avis Google
      </span>
    </a>
  );
};

export default ReviewsBadge;
